export enum Role {
    NORMAL = 1 << 0,
    TEMPLATE_ADMIN = 1 << 1,
}

export type RoleMask = number;

export interface UserModel {
    accepted_agreement: boolean | null;
    accepted_privacy_policy: boolean | null;
    accepted_usage_instructions: boolean | null;
    roles: RoleMask | null;
    org_id: string | null;
}
